module.exports = __webpack_public_path__ + "img/03.f9569dd8.svg";